<template>
  <div class="flex gap-2">
    <template v-for="(value, key) in businessSocials">
      <a
        v-if="value"
        :href="value"
        target="_blank"
        :class="getButtonColor(key)"
        class="w-8 h-8 flex items-center justify-center rounded-full"
      >
        <Icon :name="getIcon(key)" />
      </a>
    </template>
  </div>
</template>

<script setup lang="ts">
const { business } = defineProps<{ business: Business }>()
const businessSocials = reactivePick(business, 'pinterest', 'facebook', 'instagram', 'linkedin', 'tiktok', 'twitter', 'youtube')

const { getButtonColor, getIcon } = useSocials()
</script>

<style scoped></style>
